import { render } from "./GraphCuration.vue?vue&type=template&id=78523048&scoped=true"
import script from "./GraphCuration.vue?vue&type=script&lang=js"
export * from "./GraphCuration.vue?vue&type=script&lang=js"

import "./GraphCuration.vue?vue&type=style&index=0&id=78523048&scoped=true&lang=css"
import "./GraphCuration.vue?vue&type=style&index=1&id=78523048&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78523048"]])

export default __exports__